import {GiftCardFragment} from '../../../../gql/graphql';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {PriceModel} from '../Price.model';

export class GiftCardSummaryModel {
  public redeemAmount: PriceModel;

  constructor(params: GiftCardSummaryModel) {
    this.redeemAmount = params.redeemAmount;
  }

  public static fromCheckoutV1(modelContext: ModelContext, giftCard?: GiftCardFragment | null) {
    if (!giftCard) {
      return undefined;
    }
    return new GiftCardSummaryModel({
      redeemAmount: PriceModel.fromCheckoutV1(giftCard.amount, modelContext),
    });
  }
}
